<!-- Place all UI elements intended to be present across all routes in this file -->
<div class="bc-live-chat" [ngClass]="{ 'has-notifications': hasNotifications() }">

  <app-navbar></app-navbar>
  <app-keyboard-shortcuts-menu></app-keyboard-shortcuts-menu>
  <video-chat-call-toast *ngIf="isVideoFeatureEnabled"></video-chat-call-toast>
  <app-notification-bar></app-notification-bar>
  <div class="bc-main-content">
    <router-outlet></router-outlet>
  </div>
  <app-copyright></app-copyright>
</div>

<!-- SVG Icon Symbols -->
<app-svg-symbols></app-svg-symbols>
